


import { Component, Vue } from 'vue-property-decorator';

import SwitchButton from '@/shared/components/switch.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    SwitchButton,
    ExpansionPanel,
  },
})
export default class PartialSwitch extends Vue {
  private switchState: boolean = true;
}
